// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/common/activity/v1/element.proto" (package "bianka.common.activity.v1", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../../../../google/protobuf/wrappers";
import { Int32Value } from "../../../../google/protobuf/wrappers";
import { ElementType } from "../../../enums/activity/element_type";
/**
 * Next serial number to be used: 7
 *
 * @generated from protobuf message bianka.common.activity.v1.Element
 */
export interface Element {
    /**
     * Element's name
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * Element's type
     *
     * @generated from protobuf field: bianka.enums.activity.ElementType type = 2
     */
    type: ElementType;
    /**
     * Element's position inside the parent element when the order matters
     *
     * @generated from protobuf field: google.protobuf.Int32Value position = 3
     */
    position?: Int32Value;
    /**
     * Element's text value
     *
     * @generated from protobuf field: google.protobuf.StringValue text = 4
     */
    text?: StringValue;
    /**
     * Number of elements in the element
     *
     * @generated from protobuf field: optional int32 number_of_elements = 6
     */
    numberOfElements?: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class Element$Type extends MessageType<Element> {
    constructor() {
        super("bianka.common.activity.v1.Element", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["bianka.enums.activity.ElementType", ElementType, "ELEMENT_TYPE_"] },
            { no: 3, name: "position", kind: "message", T: () => Int32Value },
            { no: 4, name: "text", kind: "message", T: () => StringValue },
            { no: 6, name: "number_of_elements", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Element>): Element {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<Element>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Element): Element {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* bianka.enums.activity.ElementType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* google.protobuf.Int32Value position */ 3:
                    message.position = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.position);
                    break;
                case /* google.protobuf.StringValue text */ 4:
                    message.text = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.text);
                    break;
                case /* optional int32 number_of_elements */ 6:
                    message.numberOfElements = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Element, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* bianka.enums.activity.ElementType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* google.protobuf.Int32Value position = 3; */
        if (message.position)
            Int32Value.internalBinaryWrite(message.position, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue text = 4; */
        if (message.text)
            StringValue.internalBinaryWrite(message.text, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 number_of_elements = 6; */
        if (message.numberOfElements !== undefined)
            writer.tag(6, WireType.Varint).int32(message.numberOfElements);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.common.activity.v1.Element
 */
export const Element = new Element$Type();
